<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fal fa-draw-polygon" id="ico"></i>
		<h1 style="display: inline-block;">{{titulo}}</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<form [formGroup]="geoForm" autocomplete="off">
			<div class="row">
				<div class="col-md-5 form-group">
					<label for="nombre">Nombre</label>
					<input formControlName="nombre" class="form-control" id="economico">
					<span class="text-danger"
						*ngIf="(geoForm.get('nombre').touched) && geoForm.get('nombre').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-5" *ngIf="!esCasaLey">
					<label for="descripcion">Descripción</label>
					<input formControlName="descripcion" class="form-control" id="descripcion">
				</div>
				<div class="col-md-5" *ngIf="esCasaLey">
					<mat-form-field class="example-full-width">
						<mat-label id="matLabel">Categorias</mat-label>
						<mat-select formControlName="IdCategoriaGeo">
							<mat-option *ngFor="let categoria of categorias" [value]="categoria.id">
								{{categoria.nombre}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-md-2" style="margin-top: 2rem;">
					<button class="btnPopup agregar" mat-raised-button (click)="onSubmit()"><i id="btnIco"
							class="fal fa-save"></i>&nbsp;Guardar</button>&nbsp;
				</div>
			</div>
		</form>
	</div>
</div>
<div class="row content-cards" style="margin-left: 4px;">
	<div *ngxPermissionsOnly="[permisoVisualizarActivos]" class="col-md-4">
		<mat-card>
			<div class="data-grid">
				<h3>Activos</h3>
				<dx-data-grid [dataSource]="activosDataSource" [showBorders]="true" #usuariosGrid>
					<dxo-paging [pageSize]="5"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
					</dxo-pager>
					<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
					<ng-container>
						<dxi-column alignment="center" cellTemplate="Abrir" [width]="80">
						</dxi-column>
					</ng-container>
					<dxi-column dataField="numeroSerie" caption="Número de Serie" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
						<ng-container>
							<mat-checkbox (change)="agregarElemento(d.data.id)" [checked]="toggleCheckBox(d.data.id)">
							</mat-checkbox>
						</ng-container>
					</div>
				</dx-data-grid>
			</div>
		</mat-card>
	</div>
	<div *ngxPermissionsOnly="[permisoVisualizarVehiculos]" class="col-md-4">
		<mat-card>
			<div class="data-grid">
				<h3>Vehículos</h3>
				<dx-data-grid [dataSource]="vehiculosDataSource" [showBorders]="true" #usuariosGrid>
					<dxo-paging [pageSize]="5"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
					</dxo-pager>
					<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
					<ng-container>
						<dxi-column alignment="center" cellTemplate="Abrir" [width]="80">
						</dxi-column>
					</ng-container>
					<dxi-column dataField="imeiFk" caption="IMEI" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<dxi-column dataField="economico" caption="Económico" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<dxi-column dataField="placas" caption="Placa" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
						<ng-container>
							<mat-checkbox (change)="agregarElemento(d.data.id)" [checked]="toggleCheckBox(d.data.id)">
							</mat-checkbox>
						</ng-container>
					</div>
				</dx-data-grid>
			</div>
		</mat-card>
	</div>
	<div *ngxPermissionsOnly="[permisoVisualizarTelefonos]" class="col-md-4">
		<mat-card>
			<div class="data-grid">
				<h3>Teléfonos</h3>
				<dx-data-grid [dataSource]="telefonosDataSource" [showBorders]="true" #usuariosGrid>
					<dxo-paging [pageSize]="5"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
					</dxo-pager>
					<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
					<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
					<ng-container>
						<dxi-column alignment="center" cellTemplate="Abrir" [width]="80">
						</dxi-column>
					</ng-container>
					<dxi-column dataField="imei" caption="IMEI" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
						<ng-container>
							<mat-checkbox (change)="agregarElemento(d.data.id)" [checked]="toggleCheckBox(d.data.id)">
							</mat-checkbox>
						</ng-container>
					</div>
				</dx-data-grid>
			</div>
		</mat-card>
	</div>
	<div *ngxPermissionsOnly="[permisoVisualizarMicromedidores]" class="col-md-4 mt-3">
		<mat-card>
			<div class="data-grid">
				<h3>Micromedidores</h3>
				<dx-data-grid [dataSource]="micromedidoresDataSource" [showBorders]="true" #usuariosGrid>
					<dxo-paging [pageSize]="5"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
					</dxo-pager>
					<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
					<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
					<ng-container>
						<dxi-column alignment="center" cellTemplate="Abrir" [width]="80">
						</dxi-column>
					</ng-container>
					<dxi-column dataField="numeroSerie" caption="Número de Serie" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
						<ng-container>
							<mat-checkbox (change)="agregarElemento(d.data.id)" [checked]="toggleCheckBox(d.data.id)">
							</mat-checkbox>
						</ng-container>
					</div>
				</dx-data-grid>
			</div>
		</mat-card>
	</div>
	<div *ngxPermissionsOnly="[permisoVisualizarMedidores]" class="col-md-4 mt-3">
		<mat-card>
			<div class="data-grid">
				<h3>Medidores</h3>
				<dx-data-grid [dataSource]="medidoresDataSource" [showBorders]="true" #usuariosGrid>
					<dxo-paging [pageSize]="5"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
					</dxo-pager>
					<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
					<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
					<ng-container>
						<dxi-column alignment="center" cellTemplate="Abrir" [width]="80">
						</dxi-column>
					</ng-container>
					<dxi-column dataField="imei" caption="IMEI" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
					<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
						<ng-container>
							<mat-checkbox (change)="agregarElemento(d.data.id)" [checked]="toggleCheckBox(d.data.id)">
							</mat-checkbox>
						</ng-container>
					</div>
				</dx-data-grid>
			</div>
		</mat-card>
	</div>
</div>
